// Import Immer
import produce from 'immer';

// Import Events Constatns
import {
  GET_SINGLE_EVENT,
  GET_SINGLE_EVENT_SUCCESS,
  GET_SINGLE_EVENT_ERROR,
  GET_SIMILIAR_EVENTS,
  GET_SIMILIAR_EVENTS_SUCCESS,
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_ERROR,
  GET_COMPANIES_SUCCESS,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_ERROR,
  EDIT_EVENT,
  EDIT_EVENT_ERROR,
  EDIT_EVENT_SUCCESS,
  GET_PACKAGES, 
  GET_PACKAGES_ERROR, 
  GET_PACKAGES_SUCCESS,
  GET_COMPANIES,
  GET_EXPIRED_EVENTS,
  GET_EXPIRED_EVENTS_SUCCESS,
  GET_EXPIRED_EVENTS_ERROR
} from './constants'

export interface Loading {
  info: boolean;
  cities: boolean;
  companies: boolean;
}

// Interface
export interface eventsState {
  loading: Loading;
  loadingButton: boolean;
  loadingSimilar: boolean;
  loadingExpiredEvents: boolean;
  error: any;
  similarEvents: [],
  eventItem : object | null;
  events : Array<Object>;
  expiredEvents : Array<Object>;
  optionsCities: Array<Object>;
  page: number;
  companies: {};
  currentPage: number;
  pageCount: number;
  similarCurrentPage: number;
  similarPageCount: number;
  expiredCurrentPage: number;
  expiredPageCount: number;
  packages: Array<Object>;
}

// Setting Intial State
export const initialState: eventsState = {
  loading: {
    info: false,
    cities: false,
    companies: false,
  },
  loadingButton: false,
  loadingSimilar: false,
  loadingExpiredEvents: false,
  error: null,
  similarEvents: [],
  eventItem: null ,
  events: [],
  expiredEvents: [],
  companies: {},
  page: 1,
  currentPage: 1,
  pageCount: 1,
  similarCurrentPage: 1,
  similarPageCount: 1,
  expiredCurrentPage: 1,
  expiredPageCount: 1,
  optionsCities: [],
  packages: [],
};

/* eslint-disable default-case, no-param-reassign */
const eventsReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_SINGLE_EVENT:
        draft.loading.info = true;
        draft.eventItem = null;
        break;
      case GET_SINGLE_EVENT_SUCCESS:
        draft.eventItem = action.response.data;
        draft.loading.info = false;
        break;      
      case GET_SINGLE_EVENT_ERROR:
        draft.eventItem = action.error.response;
        draft.loading.info = false;
        draft.error = action.error.response ? action.error.response.status : 0;
        break;
      case GET_SIMILIAR_EVENTS:
        draft.loadingSimilar = true;
        break;
      case GET_SIMILIAR_EVENTS_SUCCESS:
        draft.loadingSimilar = false;
        draft.similarCurrentPage = action?.response?.data?.meta?.current_page || 1;
        draft.similarPageCount = action?.response?.data?.meta?.last_page || 1;
        draft.similarEvents = action.response.data.data;
        break;
      case GET_EVENTS:
        draft.loading.info = true;
        draft.events = [];
        break;
      case GET_EVENTS_SUCCESS:
        draft.loading.info = false;
        draft.currentPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageCount = action?.response?.data?.meta?.last_page || 1;
        draft.events = action.response.data.data;
        break;
      case GET_EVENTS_ERROR:
        draft.loading.info = false;
        draft.error = action.error;
        break;
      case GET_EXPIRED_EVENTS:
        draft.loadingExpiredEvents = true;
        draft.expiredEvents = [];
        break;
      case GET_EXPIRED_EVENTS_SUCCESS:
        draft.loadingExpiredEvents = false;
        draft.expiredCurrentPage = action?.response?.data?.meta?.current_page || 1;
        draft.expiredPageCount = action?.response?.data?.meta?.last_page || 1;
        draft.expiredEvents = action.response.data.data;
        break;
      case GET_EXPIRED_EVENTS_ERROR:
        draft.loadingExpiredEvents = false;
        draft.error = action.error;
        break;
      case GET_COMPANIES:
        draft.loading.companies = true;
        break;  
      case GET_COMPANIES_SUCCESS:
        draft.loading.companies = false;
        draft.companies = action.response.data;
        break;  
      case GET_CITIES:
        draft.loading.cities = true;
        break;
      case GET_CITIES_SUCCESS:
        draft.loading.cities = false;
        draft.optionsCities = action.response.data;
        break;
      case GET_CITIES_ERROR:
        draft.loading.cities = false;
        draft.error = action.error;
        break; 
      case EDIT_EVENT:
        draft.loadingButton = true;
        break;
      case EDIT_EVENT_SUCCESS:
        draft.loadingButton = false;
        break;
      case EDIT_EVENT_ERROR:
        draft.loadingButton = false;
        draft.error = action.error;
        break; 
      case GET_PACKAGES:
        draft.packages = [];
        break;
      case GET_PACKAGES_SUCCESS:
        draft.packages = action.response.data;
        break;
      case GET_PACKAGES_ERROR:
        draft.error = action.error;
        break;
    }
  });

export default eventsReducer;
